var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChart = function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bar-chart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M2.25 1.5a.75.75 0 0 0-1.5 0v20.25a1.5 1.5 0 0 0 1.5 1.5H22.5a.75.75 0 0 0 0-1.5H2.25zm3 9.938c0-.104.084-.188.188-.188h1.875c.103 0 .187.084.187.188v7.124a.187.187 0 0 1-.187.188H5.438a.187.187 0 0 1-.188-.187zm.188-1.688c-.932 0-1.688.755-1.688 1.688v7.124c0 .932.756 1.688 1.688 1.688h1.875c.931 0 1.687-.756 1.687-1.687v-7.125c0-.933-.756-1.688-1.687-1.688zm6.75-.75a.187.187 0 0 0-.188.188v9.375c0 .103.084.187.188.187h1.874a.187.187 0 0 0 .188-.187V9.188A.187.187 0 0 0 14.063 9zm-1.688.188c0-.932.755-1.688 1.688-1.688h1.874c.933 0 1.688.756 1.688 1.688v9.375c0 .931-.755 1.687-1.687 1.687h-1.876a1.687 1.687 0 0 1-1.687-1.687zm8.233-3c0-.104.084-.188.188-.188h1.875c.103 0 .187.084.187.188v12.375a.19.19 0 0 1-.187.187H18.92a.187.187 0 0 1-.188-.187zm.188-1.688c-.932 0-1.688.756-1.688 1.688v12.375c0 .931.756 1.687 1.688 1.687h1.875c.932 0 1.687-.756 1.687-1.687V6.188c0-.932-.755-1.688-1.687-1.688z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bar-chart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBarChart;